import { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import { Conteiner, RadioConteiner, RadioLabel, RadiosConteiner, TextoDeErro } from './styles';

export function Radio({ titulo, nome, aoAtribuirValor, opcoes = [], desabilitado = false }) {
  const inputRefs = useRef([]);
  const { fieldName, registerField, defaultValue, error } = useField(nome);

  const aoMudar = (event) => {
    aoAtribuirValor(event.target.value === 'true');
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs,
      getValue: (refs) => {
        return refs.current.find((input) => input?.checked)?.value;
      },
      setValue: (refs, id) => {
        const inputRef = refs.current.find((ref) => ref.id === id);
        if (inputRef) {
          inputRef.checked = true;
        }
      },
      clearValue: (refs) => {
        const inputRef = refs.current.find((ref) => ref.checked === true);
        if (inputRef) inputRef.checked = false;
      },
    });
  }, [fieldName, registerField]);

  useEffect(() => {
    if (defaultValue !== undefined) {
      let input = inputRefs.current.find((x) => x.value === String(defaultValue));
      if (input) {
        input.checked = true;
      }
      if (aoAtribuirValor) aoAtribuirValor(defaultValue);
    }
  }, [defaultValue, aoAtribuirValor]);

  return (
    <Conteiner>
      {titulo}
      <RadiosConteiner onChange={aoMudar}>
        {opcoes.map((option, index) => (
          <RadioConteiner key={`radio${nome}${index}`}>
            <input
              type='radio'
              ref={(ref) => {
                inputRefs.current[index] = ref;
              }}
              id={`radio${nome}${index}`}
              name={nome}
              defaultChecked={String(defaultValue) === String(option.value)}
              value={option.value}
              disabled={desabilitado}
            />
            <RadioLabel htmlFor={`radio${nome}${index}`} key={`radio${nome}${index}`}>
              {option.label}
            </RadioLabel>
          </RadioConteiner>
        ))}
      </RadiosConteiner>
      {error && <TextoDeErro>{error}</TextoDeErro>}
    </Conteiner>
  );
}
